import { Report } from "@/types/report";
import React from "react";
import { Styled } from "./styles";
import { Box, Divider, Link, Typography } from "@mui/material";
import { i18n } from "@/utils/i18n";
import { formatFullAddress, formatPersonalNumber } from "@/utils/helpers";
import SectionTitle from "@/components/ui/section-title";

interface Props {
    principal: Report["principal"];
    trustee: Report["trustee"];
}

const PersonalData: React.FC<Props> = ({ principal, trustee }) => {
    return (
        <Styled.Container>
            <SectionTitle title={i18n.t("personalData")} />
            <Box display="flex" flexDirection="row" columnGap="50px" paddingLeft="40px">
                <Box display="flex" flexDirection="column" rowGap={1.5}>
                    <Box display="flex" flexDirection="column" rowGap={0.5}>
                        <Typography variant="subtitle1">Huvudman</Typography>
                        <Typography variant="h5">{principal.name}</Typography>
                    </Box>
                    <Box display="flex" flexDirection="column" rowGap={0.5}>
                        <Typography variant="subtitle1">
                            {formatPersonalNumber(principal.personalNumber)}
                        </Typography>
                    </Box>
                </Box>
                <Divider orientation="vertical" variant="fullWidth" flexItem={true} />
                <Box display="flex" flexDirection="column" rowGap={1.5}>
                    <Box display="flex" flexDirection="column" rowGap={0.5}>
                        <Typography variant="subtitle1">God man / förvaltare/förmyndare</Typography>
                        <Typography variant="h5">{trustee.name}</Typography>
                    </Box>
                    <Box display="flex" flexDirection="column" rowGap={0.5}>
                        <Typography variant="subtitle1">
                            {formatPersonalNumber(trustee.personalNumber)}
                        </Typography>
                        <Typography variant="subtitle1">
                            {formatFullAddress(trustee.address, trustee.city)}
                        </Typography>
                        {trustee.email ? (
                            <Typography variant="subtitle1">
                                <Link href={`mailto:${trustee.email}`}>{trustee.email}</Link>
                            </Typography>
                        ) : null}
                    </Box>
                </Box>
            </Box>
        </Styled.Container>
    );
};

export default PersonalData;
